export default {
  en: {
    newMarket: 'New Market',
    market: 'Market',
    keyword: 'Keyword',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    createMarket: 'Create Market',
    createMarketAndContinueAddAgent: 'Create Market & Continue Add Agent',
    cancel: 'Cancel',
    createMarketSuccessTitle: 'Success',
    createMarketSuccessMessage: 'Create Market Success.'
  },
  th: {
    newMarket: 'สร้างตลาด',
    market: 'ตลาด',
    keyword: 'คีย์เวิร์ด',
    name: 'ชื่อ',
    description: 'รายละเอียด',
    status: 'สถานะ',
    createMarket: 'สร้างตลาด',
    createMarketAndContinueAddAgent: 'สร้างตลาด และ ต่อด้วยเพิ่มตัวแทน',
    cancel: 'ยกเลิก',
    createMarketSuccessTitle: 'สำเร็จ',
    createMarketSuccessMessage: 'สร้างตลาดสำเร็จ'
  }
}
